<body class="d-body">
  <div class="body create-course">
    <iq-central-front-end-navbar></iq-central-front-end-navbar>
    <div class="container">
      <div class="row">
        <div class="col-lg-2 col-sm-12"></div>
        <div class="col-lg-8 col-sm-12">
          <ul class="nav nav-pills mb-3 justify-content-center mt-5">
            <li class="nav-item" routerLink="/courses/create">
              <a class="nav-link">
                <span class="number">1</span> COURSE OVERVIEW</a
              >
            </li>
            <li class="nav-item" routerLink="/courses/add-lesson">
              <a class="nav-link active">
                <span class="number">2</span> ADD MODULES</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"><span class="number">3</span>CERTIFICATION</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-2 col-sm-12"></div>
      </div>
    </div>

    <section>
      <div class="py-5 container">
        <div class="py-5 text-center">
          <h3 class="font36">
            This course contains {{ lessons?.length || 0 }} Module(s)
          </h3>
          <p class="font18">
            You can create more lessons using our platform below
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div [formGroup]="lessonForm">
            <p class="text-grey font14 mb-0">MODULE</p>
            <div class="p-r edit">
              <input
                #lessonName
                formControlName="title"
                type="text"
                placeholder="Enter module name"
                class="add-lesson-name form-control"
                [ngClass]="{
                  'is-invalid':
                    lessonForm.get('title').errors &&
                    lessonForm.get('title').touched
                }"
              />
            </div>
            <div class="invalid-feedback mt-0 p-0">
              Please enter a module name
            </div>
          </div>
          <div class="text-right">
            <img src="assets/icons/more-options.png" alt="" />
            <p class="mb-0 text-grey font14 mt-3">
              {{ lessons?.length || 0 }} MODULES
            </p>
          </div>
        </div>
        <div class="text-center my-4 d-flex justify-content-end">
          <button
            class="btn bg-white px-4 mr-3"
            (click)="finish('courses')"
            [disabled]="lessonForm.invalid"
          >
            Finish
          </button>
          <button
            class="btn bg-white "
            (click)="addLessonContent()"
            [disabled]="lessonForm.invalid"
          >
            Add Content
            <span *ngIf="isLoading" class="ml-4"
              ><i class="fa fa-spinner fa-spin"></i
            ></span>
          </button>
        </div>
        <div id="accordion">
          <div class="card" *ngFor="let lesson of lessons; index as i">
            <div class="card-header" [attr.id]="'headerOne' + i">
              <a
                data-toggle="collapse"
                [attr.href]="'#collapseOne' + i"
                aria-expanded="true"
                [attr.aria-controls]="'collapseOne' + i"
              >
                <div class="d-flex justify-content-between ">
                  <div class="text-left">
                    <p class="text-grey font14 mb-0">MODULE {{ i + 1 }}</p>
                    <div class="p-r edit font24">
                      <p>{{ lesson?.title }}</p>
                    </div>
                  </div>
                  <div class="text-right">
                    <button
                      class="btn bg-white"
                      (click)="addContent(lesson?.id)"
                    >
                      Add Content
                      <span *ngIf="isLoading" class="ml-4"
                        ><i class="fa fa-spinner fa-spin"></i
                      ></span>
                    </button>
                    <p class="mb-0 text-grey font14 mt-3">
                      {{ lesson?.lessonContents?.length }} CONTENTS
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div
              [attr.id]="'collapseOne' + i"
              class="collapse "
              [attr.aria-labelledby]="'headingOne' + i"
              [attr.data-parent]="'#accordion'"
              *ngFor="let content of lesson?.lessonContents; index as j"
            >
              <div class="card-body">
                <div class="card-table table-responsive">
                  <table class="table no-wrap" id="myTable">
                    <tbody>
                      <tr class="my-3">
                        <td class="mx-3 no-wrap">0{{ j + 1 }}</td>
                        <td *ngIf="content?.contentType === 'QUIZ'">
                          <img src="assets/icons/checklist.png" alt="" />
                        </td>
                        <td *ngIf="content?.contentType === 'video'">
                          <img src="assets/icons/youtube.png" alt="" />
                        </td>
                        <td *ngIf="content?.contentType === 'pdf'">
                          <img src="assets/icons/book.png" alt="" />
                        </td>
                        <td>
                          <div class="mx-2 d-flex ">
                            <div>
                              <p class="font24 mb-0">{{ content?.name }}</p>
                              <p class="mt-1 font12 text-grey">
                                {{ content?.contentType }}- 10 MINUTES
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- <div class="text-center my-4">
                <button
                  class="btn bg-white"
                  (click)="addContent(lesson?.id)"
                  [disabled]="lessonForm.invalid"
                >
                  Add Content
                  <span *ngIf="isLoading" class="ml-4"
                    ><i class="fa fa-spinner fa-spin"></i
                  ></span>
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div class="mt-auto hidden">
    <div class="footer-wrapper container">
      <hr />
      <iq-central-front-end-footer></iq-central-front-end-footer>
    </div>
  </div>
</body>
